import { render, staticRenderFns } from "./RatingHistogram.two.vue?vue&type=template&id=23227aa1"
import script from "./RatingHistogram.two.vue?vue&type=script&lang=js"
export * from "./RatingHistogram.two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports